export default "__VITE_ASSET__BmeLMxUh__"